module.exports = __webpack_public_path__ + "img/package-banner-jp.8037a6c.png";